import { runInAction } from "mobx";
import { dashboardService } from "../services/dashboard.service";
import { dashboardFiltersStore } from "../stores/filters.store";
import { dashboardOverviewStore } from "../stores/target-data-overview.store";
import { dashboardConsolidatedMetricOverviewStore } from "../stores/consolidated-metric-overview.store";
import { buildDashboardScopePayload } from "../utils/dashboard-request-scope";
import { resolveSelectedReportingPeriod } from "../utils/reporting-years";

export const loadConsolidatedMetricOverview = async () => {
  const store = dashboardConsolidatedMetricOverviewStore;
  const { years, frameworks, categories } = dashboardFiltersStore.filters;
  const { search } = dashboardOverviewStore;
  const { page, pageSize } = store;
  const reportingPeriod = resolveSelectedReportingPeriod(
    years,
    dashboardFiltersStore.available.reportingYears,
  );

  store.setLoading(true);
  try {
    const data = await dashboardService.getConsolidatedMetricOverview({
      years,
      ...(reportingPeriod || {}),
      frameworks,
      categories,
      ...buildDashboardScopePayload({
        filters: dashboardFiltersStore.filters,
        orgTree: dashboardFiltersStore.available.orgTree,
      }),
      search,
      page,
      pageSize,
    });
    runInAction(() => {
      store.setResult(data);
    });
  } finally {
    store.setLoading(false);
  }
};
